module.exports = __webpack_public_path__ + "img/gift.3508604e.png";